import React, { useEffect, useRef } from 'react'
import { getBuyerPackageHistories } from '../../services/packageServices.ts'
import { useAuth } from '../../context/AuthContext';
import { useState } from 'react';
import { Eye } from 'lucide-react';
import { formatPrice } from '../../utils/functions.js';

const BuyerDeposit = () => {
  const { user } = useAuth();
  const [packageHistories, setPackageHistories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filterStatus, setFilterStatus] = useState('all'); // all, paid, pending
  const fetchingRef = useRef(false);

  // Check if there are any rejected packages
  const hasRejectedPackages = packageHistories.some(pkg => 
    pkg.isApproved == 0 && pkg.actionBy != null
  );

  useEffect(() => {
    if (user?.id && !fetchingRef.current) {
      fetchBuyerPackageHistories();
    }
  }, [user?.id]);

  const fetchBuyerPackageHistories = async () => {
    if (fetchingRef.current) return; // Prevent duplicate concurrent calls
    
    try {
      fetchingRef.current = true;
      setLoading(true);
      const response = await getBuyerPackageHistories(user.id, 1, 50);
      setPackageHistories(response.data);
    } catch (error) {
      console.error("Error fetching buyer package histories:", error);
      setError("Failed to load package information");
    } finally {
      setLoading(false);
      setError(null);
      fetchingRef.current = false; // Reset after fetch completes
    }
  }

  return (
    <div className="space-y-2">
      {/* Header Section */}
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-800">
          Deposit History
        </h1>
      </div>

      {/* Filter/Search Section
      <div className="bg-white rounded-lg p-6 mb-2 shadow-sm">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">From Date</label>
            <div className="relative">
              <input
                type="date"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
              />
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">To Date</label>
            <div className="relative">
              <input
                type="date"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
              />
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Search Here</label>
            <input
              type="text"
              placeholder="Search Here"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Select Status</label>
            <select className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent">
              <option value="">Select Status</option>
           
            </select>
          </div>
        </div>
        <div className="flex gap-4">
          <button className="flex items-center gap-2 px-6 py-2 bg-[#f64f2d] text-white rounded-lg hover:bg-orange-600 transition-colors">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
            Search
          </button>
          <button className="px-6 py-2 bg-[#f64f2d] text-white rounded-lg hover:bg-orange-600 transition-colors">
            Clear
          </button>
        </div>
      </div> */}

      {/* Order Table Section */}
      <div className="bg-white rounded-lg shadow-sm overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-100">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Plan Name
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Deposit
                </th>
               
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Bid Limit
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Car Limit
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Status
                </th>
                {/* <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Rejection Note
                </th> */}
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Date
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  View Receipt
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {packageHistories.map((packageHistory, index) => (
                  <tr key={index}>
                  <td className="px-6 py-4">{packageHistory.name}</td>
                  <td className="px-6 py-4">{formatPrice(packageHistory.deposit)}</td>
                  <td className="px-6 py-4">{formatPrice(packageHistory.creditLimit)}</td>
                  <td className="px-6 py-4">{packageHistory.carLimit}</td>
                   <td className="px-6 py-4">
                     {packageHistory.isApproved == 0 && packageHistory.actionBy != null ? (
                       <span
                         className="px-2 py-1 rounded-full text-xs font-medium bg-red-700 text-white cursor-pointer relative group"
                         
                       >
                         Rejected
                         {packageHistory.rejectionNote && (
                           <span className="absolute left-1/2 -translate-x-1/2 bottom-full mb-2 w-60 bg-black text-white text-sm rounded p-2 opacity-0 group-hover:opacity-100 pointer-events-none z-10 transition-opacity duration-200 whitespace-pre-line">
                             {packageHistory.rejectionNote}
                           </span>
                         )}
                       </span>
                     ) : (
                       <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                         packageHistory.isApproved == 1
                           ? 'bg-green-700 text-white'
                           : 'bg-[#f64f2d] text-white'
                       }`}>
                         {packageHistory.isApproved == 1 ? 'Approved' : 'Pending'}
                       </span>
                     )}
                   </td>
                   {/* <td className="px-6 py-4">{packageHistory.rejectionNote}</td> */}
                  <td className="px-6 py-4">{packageHistory?.actionAt
                            ? (() => {
                                const d = new Date(packageHistory.actionAt);
                                const day = d.getDate();
                                const month = d.getMonth() + 1;
                                const year = d.getFullYear();
                                return `${day}/${month}/${year}`;
                              })()
                            : "Not assigned"}</td>
                   <td className="px-6 py-4">
                     <button 
                       onClick={() => window.open(packageHistory.imageUrl, '_blank')}
                       className={`px-2 py-1 rounded-md transition-colors flex items-center gap-2 ${
                         packageHistory.isApproved == 0 && packageHistory.actionBy != null
                           ? 'bg-red-600 text-white hover:bg-red-700'
                           : 'bg-[#f64f2d] text-white hover:bg-orange-600'
                       }`}
                     >
                       <Eye className="w-4 h-4" />
                       View
                     </button>
                   </td>
                </tr>
              ))}
              {packageHistories.length === 0 && (
                <tr>
                  <td colSpan="7" className="px-6 py-12 text-center text-gray-500">
                  No Data Found.
                </td>
              </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

    </div>
  )
}

export default BuyerDeposit
